import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { Select, SelectableOption, Text } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';

import './LineItemSizeSelector.scss';

type Props = {
  item: LineItem;
  readOnly?: boolean;
  onChange: (skuId: number) => void;
  useFlex?: boolean;
};

export const LineItemSizeSelector: React.FC<Props> = ({
  item: {
    type,
    attributes: { inventory, isProductAvailable, error }
  },
  readOnly,
  onChange,
  useFlex
}) => {
  const selectedSku = useMemo(() => inventory.find(({ selected }) => selected), [inventory]);
  const selectedSkuId = selectedSku?.id;

  const handleChange = useCallback(
    (id: string) => selectedSkuId !== Number(id) && onChange(Number(id)),
    [onChange, selectedSkuId]
  );

  const options: SelectableOption[] = useMemo(
    () =>
      inventory.map(({ size, id, disabled }) => ({
        label: size,
        value: String(id),
        disabled
      })),
    [inventory]
  );

  if (readOnly)
    return <Text className="LineItemSizeSelector__size">Size: {selectedSku?.size}</Text>;

  return (
    <Select
      className={classNames('LineItemSizeSelector', {
        'LineItemSizeSelector--error': error?.type === 'SHORT_SIZE_SOLD_OUT_MESSAGE',
        'LineItemSizeSelector--flex': useFlex
      })}
      disabled={inventory.length < 2 || (type === 'cart_items' && !isProductAvailable)}
      options={options}
      onChange={handleChange}
      value={selectedSkuId?.toString()}
      label="Size"
      data-testid="lineItemSizeSelector"
      idRef={selectedSkuId?.toString()}
      paddingRight={6}
    />
  );
};
